import React from 'react';
import { modes } from './constants';
import { swap } from 'vdlib';

const useReorder = (imageUrls, mode, reorderImages, onReorderImages) => {
  const [localImageUrls, setLocalImageUrls] = React.useState(imageUrls);
  React.useEffect(() => {
    if (imageUrls) setLocalImageUrls(imageUrls);
  }, [imageUrls]);

  const handleReorder = React.useCallback(
    (e, fromIdx, toIdx, ...args) => {
      setLocalImageUrls(current => {
        const newUrls = swap(current, fromIdx, toIdx);
        onReorderImages(newUrls.map(img => img.id));
        return newUrls;
      });
    },
    [setLocalImageUrls, onReorderImages]
  );

  const reorderImageList = React.useMemo(
    () =>
      mode !== modes.Reorder || reorderImages
        ? null
        : localImageUrls.map(u => (
            <li className="auction-reorder-image" key={u.id}>
              <img src={u.thumbnail} alt="" />
            </li>
          )),
    [mode, reorderImages, localImageUrls]
  );

  return {
    handleReorder,
    localImageUrls,
    reorderImageList,
  };
};

export { useReorder };
